// helpers.js
import config from '../config';

export const buildImageUrl = (attachmentUrl) => {
  return `${config.apiURL}/attachments/${attachmentUrl}`;
};
